import { gql } from '@apollo/client';

import { Retailer } from '@rebound/shared-models/retailer/retailer.model';

export const GetRetailerBySubdomainQuery = gql`
  query getRetailerBySubdomain($subdomain: String!) {
    getRetailerBySubdomain(subdomain: $subdomain) {
      _id
      name
      subdomain
      calculateStoreCreditsEndpoint
      availableItemsToExchangeEndpoint
      createExchangeToCreditsEndpoint
      createExchangeToItemEndpoint
      returnPolicyDays
      showLastCarrier
      storeLocatorUrl
      advertisingBanner {
        banner
        mobileBanner
        tabletBanner
        url
      }
      theme {
        name
        colorScheme
        logo
        favicon
        metadata
      }
      informationCards {
        barColor
        headlineTranslations {
          key
          value
        }
        contentTranslations {
          key
          value
        }
        linkTextTranslations {
          key
          value
        }
        linkUrl
      }
      personalInfoStepDisabled
      portalDisabled
      portalDisabledMessage
      returnOptions {
        action
        isFree
      }
      createdAt
      updatedAt
      portal {
        enabledFeatures
      }
      confirmationCheckBox
      confirmationRadio
      vouchersCheckBox
      userJourneyRadio
      programTypeRadio
      termsAndConditionsCheckBox
      termsAndConditionsUrl
      confirmationTextTranslations {
        key
        value
      }
      nestedReturnReasonEnabled
      randomizeReturnReasons
      nestedReturnReasons {
        returnReasonCode
        reasonCategoryPrettyName {
          key
          value
        }
        subReasons {
          code
          prettyName {
            key
            value
          }
          hasComment
          isCommentRequired
          commentPlaceholder {
            key
            value
          }
        }
      }
      faultyItem
      returnPolicy
      support
    }
  }
`;

export type GetRetailerBySubdomainQueryResult = {
  getRetailerBySubdomain: Retailer;
};
